module.exports = __webpack_public_path__ + "static/media/_MG_0097_rsz.eca6b645.jpg";